var render, staticRenderFns
import script from "./Barrage.vue?vue&type=script&lang=js&"
export * from "./Barrage.vue?vue&type=script&lang=js&"
import style0 from "./Barrage.vue?vue&type=style&index=0&id=6d14bd2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d14bd2e",
  null
  
)

export default component.exports